import { Link as RouterLink } from 'react-router-dom';

import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import Heading from '@zenbusiness/zui/Heading';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import { superstyled } from '@zenbusiness/zui/styles';

export const DownloadContainer = superstyled({
  tag: Box,
  name: 'DownloadPage',
  slot: 'DownloadContainer',
  styles: ({ theme }) => ({
    padding: '48px 8px',
    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      padding: '32px 34px'
    }
  })
});

export const DownloadHeading = superstyled({
  tag: Heading,
  name: 'DownloadPage',
  slot: 'DownloadHeading',
  propsAdded: {
    size: '2xl',
    family: 'secondary',
    weight: 'bold'
  },
  styles: {
    marginBottom: '40px'
  }
});

export const Image = superstyled({
  tag: SharedAsset,
  name: 'DownloadPage',
  slot: 'Image',
  propsAdded: {
    height: 160,
    width: 143
  },
  styles: ({ theme }) => ({
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      height: 120,
      width: 107,
      marginBottom: theme.spacing(3)
    }
  })
});

export const MaybeLaterButton = superstyled({
  tag: Button,
  name: 'DownloadPage',
  slot: 'MaybeLaterButton',
  propsAdded: {
    variant: 'outlined',
    component: RouterLink
  },
  styles: {
    marginTop: '2em'
  }
});
